import axios from "axios";
import Swal from "sweetalert2";
import { tokenConfig } from "./websiteActions";
import { t } from "i18next";
// import _ from 'lodash';
const getPaymentTiktok =
    ({ page = 0, sizeperpage = 0, search = "", filter = {} } = {}) =>
        (dispatch, getState) => {
            dispatch({ type: "LOADING_PAYMENT_TIKTOK", payload: true });
            var param_search = "";
            if (search !== "") {
                param_search = `&search=${search}`;
            }
            filter = new URLSearchParams(filter).toString();
            if (filter) filter = `&${filter}`
            axios
                .get(`/api/payment-tiktok?page=${page}&sizeperpage=${sizeperpage}${param_search}${filter}`, tokenConfig(getState))
                .then((res) => {
                    dispatch({ type: "LOADING_PAYMENT_TIKTOK", payload: false });

                    if (res.data.status === 200) {
                        dispatch({
                            type: "ADMIN_PAYMENT_TIKTOK",
                            payload: res.data.data,
                        });
                    } else {
                        Swal.fire(t("Error"), t(res.data.message), "error");
                    }
                })
                .catch((err) => {
                    dispatch({ type: "LOADING_PAYMENT_TIKTOK", payload: false });
                    Swal.fire(t("Error"), t("An error occurred!"), "error");
                });
        };

const exportPaymentTiktoks =
    ({ search = "", filter = {} } = {}) =>
        (dispatch, getState) => {
            dispatch({ type: "LOADING_PAYMENT_TIKTOK", payload: true });
            var param_search = "";
            if (search !== "") {
                param_search = `&search=${search}`;
            }
            filter = new URLSearchParams(filter).toString();
            if (filter) filter = `&${filter}`;
            axios
                .get(`/api/payment-tiktok/exports?${param_search}${filter}`, tokenConfig(getState))
                .then((res) => {
                    dispatch({ type: "LOADING_PAYMENT_TIKTOK", payload: false });

                    if (res.data.status === 200) {
                        dispatch({
                            type: "EXPORT_PAYMENT_TIKTOK",
                            payload: res.data.data,
                        });
                    } else {
                        Swal.fire(t("Error"), t(res.data.message), "error");
                    }
                })
                .catch((err) => {
                    dispatch({ type: "LOADING_PAYMENT_TIKTOK", payload: false });
                    Swal.fire(t("Error"), t("An error occurred!"), "error");
                });
        };


export {
    getPaymentTiktok,
    exportPaymentTiktoks,
};
